import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import BlackWhiteButton from "../../../components/buttons/BlackWhiteButton";
import {
  List,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemWithImage,
  ListBodyItemAction,
  ListBodyItemLink,
  ListBodyItemSwitch,
} from "../../../components/_widgets/WidgetsList";
import api from "../../../config/api";
import { formatDate, AllEstablishment, getCategories } from "../../../config/utils";
import { Spinner } from "react-bootstrap";
require("dotenv").config();

function Store() {
  const [establishment, setEstablishment] = useState([]);

  // Filters
  const [establishmentAll, setEstablishmentAll] = useState([]);
  const [categoryAll, setCategoryAll] = useState([]);
  const [filterDropdownName, setFilterDropdownName] = useState("");
  const [selectedEstablishment, setSelectedEstablishment] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [loadActive, setLoadActive] = useState([false, 0]);

  const [loading, setLoading] = useState(true);

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    getEstablishment(pageItemsList, qtLimitItem, selectedEstablishment, selectedCategory, selectedStatus, nameFilter);
    getAll();
    getAllCategories();
  }, []);

  const getEstablishment = async (
    page,
    qtLimitItem,
    selectedEstablishment,
    selectedCategory,
    selectedStatus,
    nameFilter
  ) => {
    try {
      let response = await api.get(
        `/establishment?paginate=true&limit=${qtLimitItem}&page=${page}&selectedEstablishment=${selectedEstablishment}&category=${selectedCategory}&status=${selectedStatus}&name=${nameFilter}`
      );
      const { docs = [] } = response.data;
      setEstablishment(docs);
      setTotalItems(response.data.total);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Pagination
  const setLimitList = (value) => {
    setQtLimitItem(value);
    setPageItemsList(1);
    getEstablishment(1, value, selectedEstablishment, selectedCategory, selectedStatus, nameFilter);
  };

  const changePage = (event) => {
    setPageItemsList(Number(event.target.id));
    getEstablishment(event.target.id, qtLimitItem, selectedEstablishment, selectedCategory, selectedStatus, nameFilter);
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
      getEstablishment(
        pageItemsList - 1,
        qtLimitItem,
        selectedEstablishment,
        selectedCategory,
        selectedStatus,
        nameFilter
      );
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
      getEstablishment(
        pageItemsList + 1,
        qtLimitItem,
        selectedEstablishment,
        selectedCategory,
        selectedStatus,
        nameFilter
      );
    }
  };

  // Filter
  const getAll = async () => {
    let res = await AllEstablishment();
    setTotalItems(res.total);
    setEstablishmentAll(res.list);
  };

  const getAllCategories = async () => {
    let response = await getCategories();
    setCategoryAll(response);
  };

  const handleSelectEstablishment = (value) => {
    setSelectedEstablishment(value);
    setPageItemsList(1);

    getEstablishment(1, qtLimitItem, value, selectedCategory, selectedStatus, nameFilter);
  };

  const handleSelectCategory = (value) => {
    setSelectedCategory(value);
    setPageItemsList(1);

    getEstablishment(1, qtLimitItem, selectedEstablishment, value, selectedStatus, nameFilter);
  };

  const handleSelectStatus = (value) => {
    setSelectedStatus(value);
    setPageItemsList(1);

    getEstablishment(1, qtLimitItem, selectedEstablishment, selectedCategory, value, nameFilter);
  };

  const handleInputFilter = (value) => {
    setNameFilter(value);
    setPageItemsList(1);

    getEstablishment(1, qtLimitItem, selectedEstablishment, selectedCategory, selectedStatus, value);
  };

  // Change status
  const handleStatus = async (item, index) => {
    setLoadActive([true, index]);
    if (item.status === "disabled") {
      item.status = "active";
    } else {
      item.status = "disabled";
    }
    await api
      .patch(`/establishment-update-status/${item._id}/?status=${item.status}`)
      .then((resp) => {
        console.log(resp.data);
      })
      .catch((error) => console.log(error.message))
      .finally(() => {
        setTimeout(() => {
          setLoadActive([false, index]);
        }, 1000);
      });
    getEstablishment(pageItemsList, qtLimitItem, selectedEstablishment, selectedCategory, selectedStatus, nameFilter);
  };

  const exportTable = async () => {
    const response = await api
      .get(`/establishments-excel`, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Layout defaultMenu={1} title={"Estabelecimentos"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="d-flex flex-column flex-lg-row">
            <div className="col-12 col-lg-3 mt-2">
              <div className="input-group input-search mb-3">
                <input
                  value={nameFilter}
                  onChange={({ target }) => handleInputFilter(target.value)}
                  type="text"
                  className="form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto"
                  placeholder="Buscar"
                />
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-cl-auroMetal"></i>
                </span>
              </div>
            </div>
            <BlackWhiteButton
              onClick={() => exportTable()}
              className="mb-3 py-2"
              size={12}
              sizeLg={9}
              text="Exportar planilha"
            />
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              section={"estabelecimentos"}
              onChange={(e) => setLimitList(e.target.value)}
              limit={qtLimitItem}
              totalItem={totalItems}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              page={pageItemsList}
              changePage={(e) => changePage(e)}
            >
              <ListHeader>
                <ListHeaderItem sizeLg={3} title={"Estabelecimentos"} filter={selectedEstablishment}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          value={filterDropdownName}
                          onChange={(e) => setFilterDropdownName(e.target.value)}
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectEstablishment("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>
                      {establishmentAll
                        .filter(
                          (element) =>
                            filterDropdownName === "" ||
                            String(element.storeName).toLowerCase().includes(filterDropdownName.toLocaleLowerCase())
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            onClick={() => handleSelectEstablishment(item._id)}
                            className="dropdown-item"
                            style={
                              selectedEstablishment === item._id ? { backgroundColor: "#0d80ff", color: "white" } : {}
                            }
                          >
                            <span>{item.storeName}</span>
                          </div>
                        ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Segmento"} filter={selectedCategory}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectCategory("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>
                      {categoryAll.map((item) => (
                        <div
                          onClick={() => handleSelectCategory(item._id)}
                          className="dropdown-item"
                          style={selectedCategory === item._id ? { backgroundColor: "#0d80ff", color: "white" } : {}}
                        >
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Data de adição"} />
                <ListHeaderItem sizeLg={2} title={"Status"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {[
                        { name: "Todos", value: "" },
                        { name: "Ativo", value: "active" },
                        { name: "Inativo", value: "disabled" },
                      ].map((item, index) => (
                        <div key={index} onClick={() => handleSelectStatus(item.value)} className="dropdown-item">
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                {/* <ListHeaderItem sizeLg={3} title={"Faturas"} /> */}
              </ListHeader>
              <ListBody>
                {loading ? (
                  <>
                    <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ height: "8rem", width: "8rem", borderWidth: "0.8em" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  </>
                ) : (
                  <>
                    {establishment.length ? (
                      <>
                        {establishment.map((item, index) => (
                          <ListBodyCell
                            key={index}
                            link={`/estabelecimento/${item._id}`}
                            className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}
                          >
                            <ListBodyItemWithImage
                              sizeLg={3}
                              img={item.establishmentPhoto.length > 0 ? item.establishmentPhoto[0].url : ""}
                              description={"Estabelecimento"}
                              title={item.storeName}
                            />
                            <ListBodyItem sizeLg={2} description="Segmento" title={item.category.name} />
                            <ListBodyItem
                              sizeLg={2}
                              description={"Data de adição"}
                              title={formatDate(item.createdAt)}
                            />
                            {loadActive[0] && loadActive[1] === index ? (
                              <Spinner animation="border" role="status" className="ms-4" />
                            ) : (
                              <ListBodyItemSwitch
                                sizeLg={2}
                                onClick={() => handleStatus(item, index)}
                                value={item.status === "disabled" ? false : true}
                              />
                            )}
                            {/* <ListBodyItemLink link={"item.link"} sizeLg={2} description={"Faturas"} title={"Ver faturas"} /> */}
                            {/* <ListBodyItemAction sizeLg={1} title={"edit"}>
                      <li>
                        <span
                          className="dropdown-item fz-14 ff-univanova-regular c-pointer text-decoration-underline text-cl-azure"
                          data-bs-toggle="modal"
                          data-bs-target="#myModalSingle"
                        >
                          Editar
                        </span>
                      </li>
                      <li>
                        <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer text-decoration-underline text-cl-red">
                          Excluir
                        </span>
                      </li>
                    </ListBodyItemAction> */}
                          </ListBodyCell>
                        ))}
                      </>
                    ) : (
                      <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                        <span> Nenhum estabelecimento cadastrado</span>
                      </div>
                    )}
                  </>
                )}
              </ListBody>
            </List>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Store;
